import { render, staticRenderFns } from "./BrainSpecimenDeadDetails.vue?vue&type=template&id=e0da291e&scoped=true"
import script from "./BrainSpecimenDeadDetails.vue?vue&type=script&lang=js"
export * from "./BrainSpecimenDeadDetails.vue?vue&type=script&lang=js"
import style0 from "./BrainSpecimenDeadDetails.vue?vue&type=style&index=0&id=e0da291e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0da291e",
  null
  
)

export default component.exports